import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
// import colors from 'vuetify/lib/util/colors';

Vuetify.config.silent = process.env.NODE_ENV === 'production';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        background: '#F9F2ED',
        primary: '#0F70B7'
      }
    },
    options: { customProperties: true },
  }
});

export default vuetify;
